import { inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { BackendToastrService } from '@services/util/backend-toastr.service';

@Injectable()
export class ToastrInterceptor implements HttpInterceptor {
  private backendToastrService = inject(BackendToastrService);

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error?.error?.status === 400) {
          this.backendToastrService.cartCountSubject.next('Oops something went wrong')
          return EMPTY;
        }
        if (error?.error
          && !error?.error?.skipErrorInterceptor) {
          this.backendToastrService.cartCountSubject.next(error.error.message || 'Oops something went wrong');
          // return EMPTY;
          return throwError(() => error);
        }

        return throwError(() => error);
      })
    );
  }

}
